import { MapPrivacyLevel } from '../../types/map';
import { validatePassword } from '../../utils/throttle/validation/validation.helpers';

export const validatePrivacyLevel = (privacyLevel: MapPrivacyLevel, password?: string) => {
  return privacyLevel !== MapPrivacyLevel.PasswordProtected || validatePassword(password || '');
};
